import { render, staticRenderFns } from "./sellerDownload.vue?vue&type=template&id=27b1a86b&scoped=true"
import script from "./sellerDownload.vue?vue&type=script&lang=js"
export * from "./sellerDownload.vue?vue&type=script&lang=js"
import style0 from "./sellerDownload.vue?vue&type=style&index=0&id=27b1a86b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b1a86b",
  null
  
)

export default component.exports